import React, {Component} from 'react';
import PropTypes from 'prop-types';
import translate from '../services/translation';
import FavouritePopup from "../components/Favourites/FavouritePopup";

export class AddFavouritesApp extends Component {

    LOCAL_STORAGE_KEY = 'kontiki_favourite_itineraries';
    LOCAL_STORAGE_KEY_EXCURSIONS = 'kontiki_favourite_excursions';

    static propTypes = {
        itineraryUid: PropTypes.number,
        excursionUid: PropTypes.number,
        favouriteType: PropTypes.string,
        favouriteLink: PropTypes.string
    };

    initialState = {
        favouriteItineraries: [],
        favouriteExcursions: [],
        addFavourite: false,
        isFavouriteAdded: false
    };

    constructor(props) {
        super(props);

        this.state = this.initialState;
    }

    componentDidMount() {
        this.updateFavouritesStateFromLocalStorage();
    }

    updateFavouritesStateFromLocalStorage = (callback) => {
        const favouriteItineraries = JSON.parse(localStorage.getItem(this.LOCAL_STORAGE_KEY));
        const favouriteExcursions = JSON.parse(localStorage.getItem(this.LOCAL_STORAGE_KEY_EXCURSIONS));

        if (this.props.favouriteType === 'excursion') {
            if (favouriteExcursions !== null) {
                if (Array.isArray(favouriteExcursions)) {
                    this.setState({favouriteExcursions: favouriteExcursions}, () => typeof callback === 'function' && callback());
                } else {
                    localStorage.removeItem(this.LOCAL_STORAGE_KEY_EXCURSIONS);
                }
            } else {
                localStorage.setItem(this.LOCAL_STORAGE_KEY_EXCURSIONS, JSON.stringify(this.state.favouriteExcursions));
                localStorage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(this.state.favouriteItineraries));
            }
        }

        if (this.props.favouriteType === 'itinerary') {
            if (favouriteItineraries !== null) {
                if (Array.isArray(favouriteItineraries)) {
                    this.setState({favouriteItineraries: favouriteItineraries}, () => typeof callback === 'function' && callback());
                } else {
                    localStorage.removeItem(this.LOCAL_STORAGE_KEY);
                }
            } else {
                localStorage.setItem(this.LOCAL_STORAGE_KEY_EXCURSIONS, JSON.stringify(this.state.favouriteExcursions));
                localStorage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(this.state.favouriteItineraries));
            }
        }
    };

    toggleFavourite = () => {

        this.setState({addFavourite: true});

        setTimeout(() => {
            this.setState({addFavourite: false});
        }, 5000);

        this.updateFavouritesStateFromLocalStorage(() => {
            const {itineraryUid, excursionUid} = this.props;
            const {favouriteItineraries, favouriteExcursions} = this.state;

            if (this.props.favouriteType === 'excursion') {
                const newFavouriteExcursions = favouriteExcursions;

                if (favouriteExcursions.includes(excursionUid)) {
                    newFavouriteExcursions.splice(newFavouriteExcursions.indexOf(excursionUid), 1);
                    this.setState({favouriteExcursions: newFavouriteExcursions, isFavouriteAdded: false}, () => {
                        localStorage.setItem(this.LOCAL_STORAGE_KEY_EXCURSIONS, JSON.stringify(this.state.favouriteExcursions))
                    })
                } else {
                    newFavouriteExcursions.push(excursionUid);
                    this.setState({favouriteExcursions: newFavouriteExcursions, isFavouriteAdded: true}, () => {
                        localStorage.setItem(this.LOCAL_STORAGE_KEY_EXCURSIONS, JSON.stringify(this.state.favouriteExcursions))
                    })
                }
            }
            if (this.props.favouriteType === 'itinerary') {
                const newFavouriteItineraries = favouriteItineraries;

                if (favouriteItineraries.includes(itineraryUid)) {
                    newFavouriteItineraries.splice(newFavouriteItineraries.indexOf(itineraryUid), 1);
                    this.setState({favouriteItineraries: newFavouriteItineraries, isFavouriteAdded: false}, () => {
                        localStorage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(this.state.favouriteItineraries));
                    })
                } else {
                    newFavouriteItineraries.push(itineraryUid);
                    this.setState({favouriteItineraries: newFavouriteItineraries, isFavouriteAdded: true}, () => {
                        localStorage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(this.state.favouriteItineraries));
                    })
                }
            }
        });
    };

    render() {
        const {itineraryUid, excursionUid, favouriteType, favouriteLink} = this.props;
        const {favouriteItineraries, favouriteExcursions, addFavourite, isFavouriteAdded} = this.state;
        const conditionalClass = (favouriteItineraries.includes(itineraryUid) || favouriteExcursions.includes(excursionUid)) ? 'added' : '';

        return (
            <div className="addToFavouritesContainer">
                <div className={'addFavouriteItineraryContainer'}>
                    <button onClick={this.toggleFavourite} className={'addFavouriteItineraryButton ' + conditionalClass}>
                        <span className={'buttonText'}>
                            {(favouriteItineraries.includes(itineraryUid) || favouriteExcursions.includes(excursionUid)) ?
                                favouriteType === 'excursion' ? translate('excursion.added') : translate('favourite.added')
                                :
                                favouriteType === 'excursion' ? translate('excursion.add') : translate('favourite.add')
                            }
                        </span>
                        <span className={'buttonIcon'}/>
                    </button>
                </div>

                {addFavourite && <FavouritePopup isFavouriteAdded={isFavouriteAdded} favouriteLink={favouriteLink}/>}
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/apps/AddFavouritesApp.js